export const HUGH_COUNT = 9999999;

export const TabStatus = {
  Enabled: 'Enabled',
  Pending: 'Pending',
};
